import classNames from 'classnames';
import { SmartFormIcons, SmartFormIconVariants } from 'components';
import { Avatar, AvatarGroup, Tooltip, UserOutlinedIcon } from 'components-antd';
import { getInitials } from 'utils';
import { prepareUniqueThreadAvatar } from './helper';

import styles from './styles.module.scss';

export const CommentAvatarIndicator = ({
  hideTooltipTitle,
  commentUsers,
  dynamicComment,
  threads,
}) => {
  const uniqueThreads = prepareUniqueThreadAvatar({ dynamicComment, threads });

  const getSmartFormIcon = (lengthOfThreads, currentIndex) => {
    if (lengthOfThreads > 2 && currentIndex === 2)
      return (
        <div className={styles.commentIcon}>
          <SmartFormIcons variant={SmartFormIconVariants.CommentRed} />
        </div>
      );
    else if (currentIndex === lengthOfThreads - 1) {
      return (
        <div className={styles.commentIcon}>
          <SmartFormIcons variant={SmartFormIconVariants.CommentRed} />
        </div>
      );
    }
  };

  const getAvatar = (thread, name, i) => (
    <Tooltip
      key={`avatar-${thread.Id}`}
      title={hideTooltipTitle ? '' : name || thread.CreatorEmail}
      overlayClassName={styles.avatarNameTooltip}
    >
      <Avatar
        size={30}
        icon={!name ? <UserOutlinedIcon /> : undefined}
        className={classNames(styles.avatar, styles.commentBoxAvatar)}
        src={commentUsers[thread.CreatorId]?.avatar}
        style={{ zIndex: uniqueThreads.length - i, ...(i > 0 && { marginLeft: -12 }) }}
      >
        {getInitials(name ?? '')}
      </Avatar>
      {getSmartFormIcon(uniqueThreads.length, i)}
    </Tooltip>
  );

  return (
    <AvatarGroup maxCount={3} className={dynamicComment ? styles.dynamicAvatar : ''}>
      {uniqueThreads.map((thread, i) => {
        const name = thread.CreatorId
          ? commentUsers[thread.CreatorId]?.name
          : commentUsers[thread.CreatorEmail]?.name;

        return getAvatar(thread, name, i);
      })}
    </AvatarGroup>
  );
};
